import * as React from "react";
import { forwardRef } from "react";
const SvgComputer = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-monitor-icon lucide-monitor", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 14, x: 2, y: 3, rx: 2 }), /* @__PURE__ */ React.createElement("line", { x1: 8, x2: 16, y1: 21, y2: 21 }), /* @__PURE__ */ React.createElement("line", { x1: 12, x2: 12, y1: 17, y2: 21 }));
const ForwardRef = forwardRef(SvgComputer);
export default ForwardRef;
